import { AlertIcon as ChakraAlertIcon, AlertIconProps as ChakraAlertIconProps } from '@chakra-ui/react';

const AlertIcon = (props: ChakraAlertIconProps) => <ChakraAlertIcon {...props} />;

export { AlertIcon };
